module.exports = __webpack_public_path__ + "static/img/barrie1.36006e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/barrie1.jpg
// module id = 69
// module chunks = 9